import { IonCard, IonIcon } from "@ionic/react";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { ButtonSecondary } from "@/components/button";
import { type Shift } from "@/lib/backend/api";
import { timeIcon } from "@/lib/icons/time.icon";
import { Routes } from "@/lib/router";
import { cx } from "@/lib/style/cva.config";
import { formatInTz } from "@/utils/format-datetime";

export const ShiftCardToDeclare = forwardRef<
  HTMLIonCardElement,
  React.ComponentProps<typeof IonCard> & {
    shift: Shift;
    clockType: "MANUAL" | "QR";
  }
>(function ShiftCardToDeclare({ shift, clockType, ...props }, ref) {
  const { t, i18n } = useTranslation();
  const startAt =
    typeof shift.shiftTimeEntry?.startAt === "string"
      ? shift.shiftTimeEntry.startAt
      : shift.startAt;
  const title = (() => {
    if (clockType === "QR") {
      if (!shift.shiftTimeEntry?.startAt) {
        return t("modals:clock-in.title");
      }
      if (!shift.shiftTimeEntry?.endAt) {
        return t("modals:clock-out.title");
      }
      if (!shift.shiftTimeEntry?.breakTimeMinutes) {
        return t("modals:break-time.title");
      }
      return t("modals:declare-hours.title");
    }

    return t("modals:declare-hours.title");
  })();

  return (
    <IonCard ref={ref} {...props} className={cx("flex flex-col gap-3 p-4", props.className)}>
      <div className="flex min-w-0 flex-col">
        <h3 className="truncate text-lg font-bold">{shift.project?.name}</h3>
        <time dateTime={startAt} className="font-medium">
          {formatInTz(startAt, {
            day: "numeric",
            month: "long",
            year: "numeric",
            locale: i18n.language,
            timeZone: shift.timeZone ?? shift.project?.timeZone,
          })}
        </time>
      </div>

      <ButtonSecondary
        routerLink={shift.projectId ? Routes.Project({ id: shift.projectId }) : undefined}
      >
        <div className="flex items-center gap-2">
          {title}
          <IonIcon icon={timeIcon} className="size-4" />
        </div>
      </ButtonSecondary>
    </IonCard>
  );
});
